import * as React from 'react';

/** Material UI Packages. */
import { Box, OutlinedInput, Typography } from '@mui/material';

/** Internal Components. */
import CustomSnackbar from 'shared/ui/CustomSnackbar';
import { SHIPMENT_CATEGORIES } from 'shared/config/constantsData';

/** Preset note component. */
export default function PresetNote(props) {
    /** Get props from ApplySetting.js. */
    const { selectedNote, handleNoteContent } = props;

    return (
        <Box
            sx={{
                bgcolor: 'white',
                borderRadius: '10px',
                boxShadow: '0px 1px 2px 1px rgba(0, 0, 0, 0.1)',
                p: 1.5,
                height: '100%',
            }}
        >
            <Typography sx={{ mb: 1, fontSize: 11 }}>
                Currently editing:{' '}
                <Box component="span" sx={{ color: '#2488a2' }}>
                    {SHIPMENT_CATEGORIES[selectedNote.index]}
                </Box>
                {' > '}
                <Box component="span" sx={{ fontWeight: 'bold', color: '#00647e' }}>
                    {selectedNote.progress.label}
                </Box>
            </Typography>
            <OutlinedInput
                placeholder="Please leave a comment..."
                multiline
                maxRows={14}
                minRows={14}
                value={selectedNote.content}
                onChange={handleNoteContent}
                sx={{
                    width: '100%',
                    fontSize: 13,
                    p: 1.5,
                }}
            />
            <CustomSnackbar />
        </Box>
    );
}
